import { useEffect, useState } from "react";
import axios from "axios";
const DEFAULT = {
    maintenance: { enabled: false, title: "", message: "", contact_info: "" },
    popup: null,
};
const POLL_INTERVAL = 60000; // 60 seconds
export function useStatus() {
    const [status, setStatus] = useState(DEFAULT);
    async function fetchStatus() {
        try {
            const base = (process.env.API_URL || '') + '/v1';
            const { data } = await axios.get(`${base}/vendor/status`);
            setStatus(data);
        }
        catch {
            // Silently fail — don't block the app
        }
    }
    useEffect(() => {
        fetchStatus();
        const interval = setInterval(fetchStatus, POLL_INTERVAL);
        return () => clearInterval(interval);
    }, []);
    return status;
}
